import {CanActivateFn, Router} from '@angular/router';
import {OidcSecurityService} from "angular-auth-oidc-client";
import {catchError, from, map, of, switchMap} from "rxjs";
import {inject} from "@angular/core";
import {AuthenticationService} from "../services/authentication.service";
import {Company} from "../../shared/models/company";
import {User} from "../../shared/models/user";
import {Role} from "../../shared/models/roles.model";

export const authGuard: CanActivateFn = (route, state) => {
  const oidcService = inject(OidcSecurityService);
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return oidcService.checkAuth(undefined).pipe(
    switchMap(({ isAuthenticated }) => {
      if (!isAuthenticated) {
        oidcService.authorize();
        return of(false);
      }

      return oidcService.getUserData().pipe(
        switchMap(userData => {
          return authService.getLoggedUser().pipe(
            // Cambiar map por switchMap para manejar la promesa
            switchMap(rsp => {
              if (userData && !authService.loggedUser$.value?.reports) {
                authService.loggedUser = rsp;
                // Convertir la promesa en observable
                return from(authService.loadAllUserData()).pipe(
                  map(() => true)
                );
              }
              return of(true);
            }),
            catchError(error => {
              console.error(error);
              authService.loggedUser = undefined;
              return of(false);
            })
          );
        })
      );
    })
  );
};
